/**
 * Datos mock centralizados para el módulo Registros de Uso
 * Estos datos serán reemplazados por datos reales del API en la Fase 7
 */

// Datos mock para la tabla de usuarios
export const MOCK_USERS = [
    { id: 1, identificacion: '1075689548', celular: '3115678901', cantidadMediciones: 25, participacion: 100 },
    { id: 2, identificacion: '10205254865', celular: '3214567890', cantidadMediciones: 3, participacion: 75 },
    { id: 3, identificacion: '1095784632', celular: '3523456789', cantidadMediciones: 4, participacion: 100 },
    { id: 4, identificacion: '1023456789', celular: '3001234567', cantidadMediciones: 2, participacion: 50 },
    { id: 5, identificacion: '1034567890', celular: '3112345678', cantidadMediciones: 5, participacion: 100 },
    { id: 6, identificacion: '1045678901', celular: '3223456789', cantidadMediciones: 1, participacion: 25 },
    { id: 7, identificacion: '1056789012', celular: '3334567890', cantidadMediciones: 4, participacion: 80 },
    { id: 8, identificacion: '1067890123', celular: '3445678901', cantidadMediciones: 3, participacion: 60 },
    { id: 9, identificacion: '1078901234', celular: '3556789012', cantidadMediciones: 5, participacion: 100 },
    { id: 10, identificacion: '1089012345', celular: '3667890123', cantidadMediciones: 2, participacion: 40 },
    { id: 11, identificacion: '1090123456', celular: '3778901234', cantidadMediciones: 4, participacion: 80 },
    { id: 12, identificacion: '1001234567', celular: '3889012345', cantidadMediciones: 1, participacion: 20 },
];

// Datos mock para la tarjeta de Implementación
export const MOCK_IMPLEMENTATION_DATA = {
    measuredUsers: 365,
    totalUsers: 500,
    implementationPercentage: 73,
    usersWithoutMeasurements: 135,
};

// Datos mock para la tarjeta de Participación
export const MOCK_PARTICIPATION_DATA = {
    totalMeasurements: 1254,
    averageParticipation: 81,
    lowParticipationUsers: 52,
};

// Datos mock para la gráfica de dona
export const MOCK_CHART_DATA = {
    measuredUsers: 365,
    usersWithoutMeasurements: 135,
};

// Opciones mock para filtros (para uso futuro)
export const MOCK_FILTER_OPTIONS = {
    stations: [
        { id: 1, name: 'EVBI 001' },
        { id: 2, name: 'EVBI 002' },
        { id: 3, name: 'EVBI 003' },
    ],
    companies: [
        { id: 1, name: 'Empresa A' },
        { id: 2, name: 'Empresa B' },
        { id: 3, name: 'Empresa C' },
    ],
    areas: [
        { id: 1, name: 'Producción' },
        { id: 2, name: 'Administración' },
        { id: 3, name: 'Logística' },
    ],
    positions: [
        { id: 1, name: 'Operario' },
        { id: 2, name: 'Supervisor' },
        { id: 3, name: 'Gerente' },
    ],
};

export default {
    MOCK_USERS,
    MOCK_IMPLEMENTATION_DATA,
    MOCK_PARTICIPATION_DATA,
    MOCK_CHART_DATA,
    MOCK_FILTER_OPTIONS,
};
